"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const navigation_1 = __importDefault(require("@App/navigation"));
const generateEditLink = (workStep, viewWorkId, rightsholderId, workType) => {
    if (!workType || !rightsholderId) {
        return navigation_1.default.home.root();
    }
    switch (workType) {
        case 'bulk':
            return navigation_1.default.rightholder.createWork.bulk.edit[workStep](rightsholderId);
        case 'create-form':
            return navigation_1.default.rightholder.createWork.form[workStep](rightsholderId);
        case 'create-wizard':
            return navigation_1.default.rightholder.createWork.wizard[workStep](rightsholderId);
        case 'draft':
            return navigation_1.default.rightholder.registrationDrafts[workStep](rightsholderId, workType, viewWorkId);
        default:
            return navigation_1.default.rightholder.catalog.workEdit[workStep](rightsholderId, workType, viewWorkId);
    }
};
exports.default = generateEditLink;
